/** @jsx jsx */

import { Colors, Spacing } from '@zapier/theme';
import { jsx, css } from '@emotion/core';

import ToggleSwitch from 'app/common/components/ToggleSwitch';

import type { RequestOptions } from 'app/developer-v3/platformSchema/request';

const Styles = {
  root: css`
    position: relative;
  `,
  content: css`
    padding: ${Spacing.medium}px;
  `,
  overlay: css`
    user-select: none;
    cursor: not-allowed;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: ${Colors.grey000};
    opacity: 0.7;
  `,
  wrapper: css`
    :not(:last-of-type) {
      margin-bottom: ${Spacing.medium}px;
    }
  `,
  toggle: css`
    margin-right: 12px;
  `,
};

type Props = {
  isDisabled: boolean;
  onChangeOptions: (name: string, isOn: boolean) => void;
  removeMissingValuesFrom: RequestOptions;
};

const defaultProps = {
  isDisabled: false,
  removeMissingValuesFrom: {},
};

function Options({
  isDisabled = defaultProps.isDisabled,
  onChangeOptions,
  removeMissingValuesFrom = defaultProps.removeMissingValuesFrom,
}: Props) {
  const { body: isOnBody, params: isOnParams } = removeMissingValuesFrom;

  return (
    <div aria-label="Options tab content" css={Styles.root}>
      {isDisabled && <div aria-label="Overlay" css={Styles.overlay} />}
      <div css={Styles.content}>
        <div aria-label="Omit empty parameters" css={Styles.wrapper}>
          <ToggleSwitch
            css={Styles.toggle}
            isOn={isOnParams}
            onToggle={() => onChangeOptions('params', !isOnParams)}
          />
          <span>Automatically omit parameters that are empty</span>
        </div>
        <div aria-label="Omit empty body fields" css={Styles.wrapper}>
          <ToggleSwitch
            css={Styles.toggle}
            isOn={isOnBody}
            onToggle={() => onChangeOptions('body', !isOnBody)}
          />
          <span>
            Automatically omit fields in the request body that are empty
          </span>
        </div>
      </div>
    </div>
  );
}

Options.defaultProps = defaultProps;

export default Options;
